<template>
  <el-dialog
    title="冻结订单"
    :visible="show"
    @close="closeDialog"
    @open="openDialog"
    :close-on-click-modal="false"
  >
    <el-form :model="form" :rules="rules" ref="form">
      <el-form-item label="订单号" prop="orderId" :label-width="formLabelWidth">
        <el-col :span="24">
          <el-input
            size="small"
            type="text"
            v-model="form.orderId"
            placeholder="请输入订单号"
            :disabled="type ? true : false"
          ></el-input>
        </el-col>
      </el-form-item>

      <el-form-item
        label="冻结金额"
        prop="amount"
        :label-width="formLabelWidth"
      >
        <el-col :span="24">
          <el-input
            size="small"
            type="text"
            v-model="form.amount"
            placeholder="请输入冻结金额"
            @input="val => handleInput(val, 'amount')"
            :disabled="type ? true : false"
          ></el-input>
        </el-col>
      </el-form-item>

      <el-form-item label="appId" :label-width="formLabelWidth" prop="appId">
        <el-col :span="24">
          <el-select
            v-model="form.appId"
            placeholder="请选择"
            :popper-append-to-body="false"
            popper-class="eloption"
            size="small"
            style="width: 100%"
            :disabled="type ? true : false"
          >
            <el-option
              v-for="merchant in merchantList"
              :label="merchant.value + '-' + merchant.name"
              :key="merchant.value"
              :value="merchant.value"
            ></el-option>
          </el-select>
        </el-col>
      </el-form-item>

      <el-form-item label="备注" prop="remark" :label-width="formLabelWidth">
        <el-col :span="24">
          <el-input
            size="small"
            type="textarea"
            v-model="form.remark"
            placeholder="请输入备注"
          ></el-input>
        </el-col>
      </el-form-item>

      <el-form-item label="联系邮箱" prop="contactInfo" :label-width="formLabelWidth">
        <el-col :span="24">
          <el-input
            size="small"
            type="text"
            v-model="form.contactInfo"
            placeholder="请输入客户联系邮箱"
          ></el-input>
        </el-col>
      </el-form-item>

    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="saveFronzen">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'SystemEdit',
  props: {
    show: Boolean,
    merchantList: Array,
    item: {
      type: Object,
      default: () => {},
    },
    type: String,
  },

  created() {},
  data() {
    return {
      dialogShow: this.show,
      form: {
        appId: '',
        remark: '',
        orderId: '',
        amount: '',
        contactInfo: '',
      },
      formLabelWidth: '100px',
      rules: {
        orderId: [
          { required: true, message: '请输入订单号', trigger: 'blur' },
          { min: 12, message: '订单号不小于12位', trigger: 'blur' },
        ],
        amount: [
          { required: true, message: '请输入冻结金额', trigger: 'blur' },
        ],
        appId: [{ required: true, message: '请选择appId', trigger: 'change' }],
        remark: [{ required: true, message: '请输入备注', trigger: 'blur' }],
      },
    }
  },
  methods: {
    agentNameChange() {},

    openDialog() {
      if (this.type) {
        this.form.orderId = this.item.orderId
        this.form.amount = this.item.amount / 100
        this.form.appId = this.item.appId
      }
    },
    closeDialog() {
      this.form = {
        appId: '',
        remark: '',
        orderId: '',
        amount: '',
        contactInfo: '',
      }
      this.$refs['form'].resetFields() //关闭的时候重置表单
      this.$emit('update:show', false)
    },
    handleInput(val, type) {
    },
    saveFronzen() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          const params = {
            ...this.form,
            amount: this.form.amount,
            freezeType: this.type ? '00' : '01',
            freezeStatus: '01',
          }
          this.$axios
            .post('/freezeBalance/precessFreezeBalance', params)
            .then(res => {
              if (res.code === 200) {
                this.$notify({
                  title: '提示',
                  message: res.msg,
                  type: 'success',
                })

                this.closeDialog()
                this.$emit('update:show', false)
                this.$bus.$emit('refresh') //通知刷新
              } else {
                this.$notify.error({
                  title: '提示',
                  message: res.msg,
                })
              }
            })
        } else {
          return false
        }
      })
    },
  },
  watch: {
    show(newVal) {
      this.dialogShow = newVal
    },
  },
}
</script>

<style scoped>
</style>